// FIXME: update fallback API URL
export const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8088/v1';


// WEBPACK FOOTER //
// ./src/services/common.ts